export const copy = Object.freeze({
  appName: "PAWS",
  tagline: "Inquadra il tuo cane e scopri come si sente",
  modelLoading: "Preparo l'analisi…",
  modelDownloading: (pct) => `Scarico il modello di analisi… ${pct}%`,
  modelReady: "Analisi pronta",
  modelMissing: "Il modello di analisi non è ancora disponibile. Riprova più tardi.",
  modelError: "Non riesco a preparare l'analisi. Controlla la connessione e riprova.",
  cameraDenied: "Non ho il permesso di usare la fotocamera. Abilitalo nelle impostazioni del browser.",
  cameraMissing: "Nessuna fotocamera trovata su questo dispositivo.",
  cameraError: "La fotocamera non risponde. Chiudi altre app che la usano e riprova.",
  uncertain: "Non sono sicuro: prova a inquadrare meglio il muso e il corpo del cane, con più luce.",
  explainError: "Spiegazione non disponibile in questo momento. Riprova tra poco.",
  offline: "Sei offline: l'analisi funziona lo stesso, la spiegazione dettagliata no.",
  feedbackThanks: "Grazie! Il tuo aiuto rende PAWS più preciso.",
  feedbackError: "Non sono riuscito a inviare il feedback. Riprova più tardi.",
  feedbackRemoved: "Feedback e foto eliminati.",
  feedbackRemoveError: "Non sono riuscito a eliminare il feedback. Riprova più tardi.",
  videoError: "Non riesco a leggere questo video. Prova con un altro file.",
  imageError: "Non riesco ad aprire questa immagine. Prova con un'altra foto.",
  liveNeedsModel: "La modalità Live sarà disponibile appena l'analisi rapida è pronta. Intanto puoi scattare una foto o registrare una clip.",
  offlineNoModel: "Sei offline e l'analisi rapida non è ancora stata scaricata. Riprova con la connessione attiva.",
  engineAdvanced: "Analisi avanzata",
  engineQuick: "Analisi rapida",
  readyOnline: "Pronta con connessione",
  shareError: "Non sono riuscito a preparare la condivisione.",
  voiceTitle: "Voce",
  voiceHint: "Scegli la voce che legge ad alta voce la spiegazione del tuo cane.",
  voiceSample: "Ciao! Sono PAWS: ti racconto come si sente il tuo cane.",
  voiceSaved: (name) => `Voce impostata su ${name}.`,
  voiceError: "Non riesco a leggere ad alta voce in questo momento.",
  noDog: "Non vedo un cane nell'inquadratura: avvicinati e tieni muso e corpo dentro il riquadro.",
  liveNoDog: "Nessun cane inquadrato",
  boxesOn: "Riquadro sul cane attivo.",
  boxesOff: "Riquadro sul cane disattivato.",
  tapToAnalyze: "Tocca l'anteprima per analizzare",
  tapLiveHint: "Tocca l'anteprima per il risultato",
  coachTitle: "Guida vocale",
  coachHint: "Quando tocchi per analizzare o avvii una clip, PAWS ti parla: consigli su come riprendere il cane e le sue osservazioni su di lui.",
  coachLiveHint: "In modalità Live resta zitta, a meno che non la accendi qui: parlerebbe ogni pochi secondi.",
  coachLiveOn: "Guida vocale attiva anche in Live.",
  coachLiveOff: "In Live la guida vocale resta zitta.",
  coachOn: "Guida vocale attiva: ti parlo mentre inquadri.",
  coachOff: "Guida vocale disattivata.",
  devUnlocked: "Modalità sviluppatore attiva.",
  devLocked: "Modalità sviluppatore disattivata.",
  devHint: (missing) => `Ancora ${missing} tocchi…`,
  devDetector: (best, boxes) => `Dev · rilevatore: punteggio massimo ${(best * 100).toFixed(0)}%, riquadri ${boxes}`
});
